import styled from '@emotion/styled'
export const ResponsiveContainer = styled.div`
  ${tw`sm:w-mobile lg:w-1110 mx-auto`}
  @media only screen and (min-width: 768px) and (max-width: 1180px) {
    ${tw`w-92%`}
  }
`